module.exports = __webpack_public_path__ + "img/eps_pi_en.ba172c40.png";